import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { compose } from 'recompose'

import { Modal, Export } from 'containers/misc'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { FilterAwardsOfficeSignoff } from 'containers/filters'
import { Text } from 'components/layout'
import { Table, Data } from 'components/layout/Table'
import { BadgesLevels, Button, ButtonGroup } from 'components/misc'
import { TasksAwardLeaderNote } from 'components/sections/tasks'
import { tasks as tasksLayout } from 'constants/layout'
import {
  apiTasksAwardSignoff,
  apiAwards,
  apiConfiguration
} from 'helpers/decorators/api'
import { modal } from 'redux/modules/app'
import { meta, permissions, tableCommon } from 'helpers/decorators'
import config from 'config'
import { CONFIGURATION_KEYS } from 'constants/enums'
import { initialize } from 'redux-form'
import { getLabels } from '../../../helpers/labelHelper'
import { tasks as tasksApi } from '../../../redux/modules/api'

const enhance = compose(
  meta({
    title: 'Awards',
    intlKey: 'route.awards'
  }),
  apiConfiguration(),
  apiTasksAwardSignoff({
    officeLocally: true,
    useCommonLimit: true
  }),
  apiAwards({
    updateOfficeSignoffTasksLocally: true
  }),
  permissions(),
  tableCommon(),
  connect(
    ({ auth }) => ({
      activeOrganizationId: auth.organization.id
    }),
    {
      modal,
      setFilter: tasksApi.awardSignoff.setAwardOfficeSignoffFilter
    }
  )
)

class TasksAwardsOfficeSignoffLocally extends Component {
  static propTypes = {
    tasks: PropTypes.object.isRequired,
    configuration: PropTypes.object,
    activeOrganizationId: PropTypes.number,
    setOfficeParams: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    exportAwardOfficeLocallyTasks: PropTypes.func.isRequired,
    approveSignoffAwardOffice: PropTypes.func.isRequired,
    returnSignoffAwardOffice: PropTypes.func.isRequired,
    permissions: PropTypes.object.isRequired,
    setCommonLimit: PropTypes.func,
    initialize: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired
  }

  state = {
    awardOfficeApproveSignoffId: null,
    awardOfficeReturnSignoffId: null,
    awardOfficeNote: null
  }

  handleApproveSignoffModal = awardOfficeApproveSignoffId => {
    this.setState(
      {
        awardOfficeApproveSignoffId
      },
      () => {
        this.props.modal('modal-approve-award-office')
      }
    )
  }

  handleReturnSignoffModal = awardOfficeReturnSignoffId => {
    this.setState(
      {
        awardOfficeReturnSignoffId
      },
      () => {
        this.props.modal('modal-return-award-office')
      }
    )
  }

  handleNoteAwardOffice = awardOfficeNote => {
    this.setState(
      {
        awardOfficeNote
      },
      () => {
        this.props.modal(`modal-note-award-office-${this.key}`)
      }
    )
  }

  addLabelToFilter = label => {
    let initValues = []

    initValues.push({ value: label.id, label: label.name })
    this.props.dispatch(initialize(
        'awards-office-signoff-filter',
        { 'award_participant_labels_label_id@or' : initValues }
    ))
    this.props.setFilter(`award.participant.labels.label.id=${label.id}`)
  }

  render() {
    const {
      tasks: { office: { loading, list, offset, limit, pages, sort } },
      approveSignoffAwardOffice,
      returnSignoffAwardOffice,
      setOfficeParams,
      configuration,
      activeOrganizationId,
      permissions: userPermissions,
      setCommonLimit
    } = this.props

    const isLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganizationId}][${CONFIGURATION_KEYS.enableLabels.id}].booleanValue`)

    const isOffline = get(
      configuration,
      `valuesByOrganizationId[${activeOrganizationId}][${CONFIGURATION_KEYS.offlineAu.id}].booleanValue`,
      'xxx'
    )

    const showOA = userPermissions.isNaoStaff || userPermissions.isIfSuper

    const showCountry = userPermissions.isGbt

    const ExportComponent = (
      <Export
        exportName="Award office sign-offs"
        toExport={this.props.exportAwardOfficeLocallyTasks}
        exportSchemeValue="awards-office-locally"
        count={this.props.tasks && this.props.tasks.count}
        additionalParams={{
          includeCountry: showCountry
        }}
      />
    )

    return (
      <div>
        <FilterAwardsOfficeSignoff showCountry={showCountry} />
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={tasksLayout.awardOfficeSignoff({
            isOffline,
            showCountry,
            showOA,
            isLabelsEnabled
          })}
          setParams={setOfficeParams}
          exportComponent={ExportComponent}
        >
          <Data>
            {list.map(({ id, award, organization, note }) => (
              <tr key={id}>
                <td>
                  <Link to={`${config.publicPath}/participants/${get(award, 'participant.id')}`}>
                    {get(award, 'participant.globalId') ||
                      get(award, 'participant.id')}
                  </Link>
                </td>
                <td>{get(award, 'participant.firstName')}</td>
                <td>
                  <Text maxWidth={150}>
                    {get(award, 'participant.lastName')}
                  </Text>
                </td>
                <td>
                  {get(award, 'previousCompletedAwardLevel')
                    ? <BadgesLevels
                        levels={[
                          {
                            awardLevel: get(
                              award,
                              'previousCompletedAwardLevel'
                            )
                          }
                        ]}
                        single
                      />
                    : '---'}
                </td>
                <td>
                  <BadgesLevels levels={[award]} single />
                </td>
                <td>
                  {get(organization, 'name')}
                </td>
                <td>
                  {get(award, 'startDate') &&
                    <FormattedDate value={award.startDate} />}
                </td>
                <td>
                  {get(award, 'leaderSignoffDate') &&
                    <FormattedDate value={award.leaderSignoffDate} />}
                </td>
                {showCountry &&
                  <td>
                    {get(award, 'organization.country.name') || get(organization, 'country.name')}
                  </td>
                }
                {showOA && <td>{get(organization, 'parentOA.name') || '---'}</td>}
                <td>{get(organization, 'parentSubOA.name') || '---'}</td>
                <td>{award.signoffRequestAttemptsCount}</td>
                {isLabelsEnabled && <td>
                  {get(award, 'participant.labels') && getLabels(get(award, 'participant.labels'), this.addLabelToFilter)}
                </td> }
                <td>
                    { note
                      ? <Button tertiary className="link" intlKey="button.view" onClick={() => this.handleNoteAwardOffice(note)} >View</Button>
                      : <FormattedMessage id="label.no_note" defaultMessage="No note" /> }
                </td>
                {isOffline &&
                  <td>
                    {get(award, 'awardMode.translationText')}
                  </td>}
                <td>
                  {get(award, 'awardType.translationText')}
                </td>
                <td>
                  <ButtonGroup>
                    <Button
                      tiny
                      onClick={() =>
                        this.handleApproveSignoffModal(get(award, 'id'))}
                      intlKey="button.approve"
                    >
                      Approve
                    </Button>
                    <Button
                      tiny
                      onClick={() =>
                        this.handleReturnSignoffModal(get(award, 'id'))}
                      intlKey="button.revise"
                      secondary
                    >
                      Revise
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </Data>
        </Table>
        <Modal id="modal-approve-award-office" customActions>
          <TaskApprove
            approve={approveSignoffAwardOffice}
            id={this.state.awardOfficeApproveSignoffId}
            modal={this.props.modal}
            title="Approve award"
          />
        </Modal>
        <Modal id="modal-return-award-office" customActions>
          <TaskReturn
            returnTask={returnSignoffAwardOffice}
            id={this.state.awardOfficeReturnSignoffId}
            modal={this.props.modal}
            title="Return award"
          />
        </Modal>
        <Modal id={`modal-note-award-office-${this.key}`}>
          <TasksAwardLeaderNote note={this.state.awardOfficeNote} fromLeader />
        </Modal>
      </div>
    )
  }
}

export default enhance(TasksAwardsOfficeSignoffLocally)
